import { Ability } from '@casl/ability'
// import store from '@/store'
import { initialAbility } from './config'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
// const userData = JSON.parse(localStorage.getItem('userData'))
// const userData = localStorage.getItem('userData')

// const existingAbility = store.getters['permissions/getPermissions']

export default new Ability(initialAbility)
